/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */
import { ProfileType } from './profile-type.model';


export class Profile {
    id?: number; // ecf001
    personUUID?: string;
    complete?: boolean; // ecf001
    readOnly?: boolean; // ecf001
    lastModificationDate?: string; // ecf001
    firstName?: string; // ecf001
    lastName?: string; // ecf001
    status?: string; // ecf001
    type?: ProfileType; // ecf001
    nrn?: string
    foreignerUserId?: string;
    loggedOnVia?: string;
    sites?: any[];
    formAccessDate?: string;


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): Profile {
        if (!data) { return instance; }
        if (data.id != null) {instance.id = data.id; }
        if (data.complete != null) {instance.complete = data.complete; }
        if (data.readOnly != null) {instance.readOnly = data.readOnly; }
        if (data.lastModificationDate != null) {instance.lastModificationDate = data.lastModificationDate; }
        if (data.firstName != null) {instance.firstName = data.firstName; }
        if (data.lastName != null) {instance.lastName = data.lastName; }
        if (data.status != null) {instance.status = data.status; }
        if (data.type != null) {instance.type = data.type; }
        if (data.nrn != null) {instance.nrn = data.nrn; }
        if (data.foreignerUserId != null) {instance.foreignerUserId = data.foreignerUserId; }
        if (data.loggedOnVia != null) {instance.loggedInVia = data.loggedInVia;}
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return Profile.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: Profile) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return Profile.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: Profile): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
